// ================= CONTENTPAGE_LIST =================== //

export const CONTENTPAGE_LIST = "CONTENTPAGE_LIST";
export const CONTENTPAGE_LIST_SUCCESS = "CONTENTPAGE_LIST_SUCCESS";
export const CONTENTPAGE_LIST_FAIL = "CONTENTPAGE_LIST_FAIL";

// ================= CONTENT_LIST_DETAILS =================== //
export const CONTENT_LIST_DETAILS = "CONTENT_LIST_DETAILS";
export const CONTENT_LIST_DETAILS_SUCCESS =
  "CONTENT_LIST_DETAILS_SUCCESS";
export const CONTENT_LIST_DETAILS_FAIL = "CONTENT_LIST_DETAILS_FAIL";

// ================= CONTENTPAGE_EDIT =================== //

export const CONTENTPAGE_EDIT = "CONTENTPAGE_EDIT";
export const CONTENTPAGE_EDIT_SUCCESS = "CONTENTPAGE_EDIT_SUCCESS";
export const CONTENTPAGE_EDIT_FAIL = "CONTENTPAGE_EDIT_FAIL";
